import { CoeDataAnalysisPackageConfigEntityModel } from "src/store/models/entity/coeDataAnalysisPackageConfig/entity";
import { CoeDataAnalysisPackageConfigHelperModel } from "src/store/models/entity/coeDataAnalysisPackageConfig/helper";

export const encooCoeDataAnalysisPackageConfigModels = {
  entity: CoeDataAnalysisPackageConfigEntityModel,
  helper: CoeDataAnalysisPackageConfigHelperModel,
};
